function isTest() {
  return !window.location.href.startsWith("https://tax.za.mercury.global");
}

export default {
  isTest
}